import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
var _excluded = ["children", "className", "component", "error", "disabled", "mode", "dangerouslyForceHoverStyling", "dangerouslyForceFocusStyling"];
import React from 'react';
import classNames from 'classnames';
import style from './ActionBlock.module.less';

var calculateStyles = function calculateStyles(_ref) {
  var _ref2;

  var error = _ref.error,
      disabled = _ref.disabled,
      className = _ref.className,
      mode = _ref.mode,
      dangerouslyForceHoverStyling = _ref.dangerouslyForceHoverStyling,
      dangerouslyForceFocusStyling = _ref.dangerouslyForceFocusStyling;
  return classNames([style['action-block'], className, (_ref2 = {}, _defineProperty(_ref2, style.self, mode === 'self'), _defineProperty(_ref2, style.group, mode === 'group'), _defineProperty(_ref2, style.container, mode === 'container'), _defineProperty(_ref2, style['force-hover'], dangerouslyForceHoverStyling), _defineProperty(_ref2, style['force-focus'], dangerouslyForceFocusStyling), _defineProperty(_ref2, style.error, error), _defineProperty(_ref2, style.disabled, disabled), _ref2)]);
};

export var ActionBlock = /*#__PURE__*/React.forwardRef(function (_ref3, ref) {
  var children = _ref3.children,
      className = _ref3.className,
      _ref3$component = _ref3.component,
      Component = _ref3$component === void 0 ? 'div' : _ref3$component,
      error = _ref3.error,
      disabled = _ref3.disabled,
      _ref3$mode = _ref3.mode,
      mode = _ref3$mode === void 0 ? 'self' : _ref3$mode,
      dangerouslyForceHoverStyling = _ref3.dangerouslyForceHoverStyling,
      dangerouslyForceFocusStyling = _ref3.dangerouslyForceFocusStyling,
      otherProps = _objectWithoutProperties(_ref3, _excluded);

  return /*#__PURE__*/React.createElement(Component, _extends({
    className: calculateStyles({
      className: className,
      error: error,
      disabled: disabled,
      mode: mode,
      dangerouslyForceHoverStyling: dangerouslyForceHoverStyling,
      dangerouslyForceFocusStyling: dangerouslyForceFocusStyling
    }) // @ts-expect-error -- This is a type error because our default component is
    // `<div>`, but `<div>` doesn't accept a `disabled` prop. We need to
    // unconditionally forward it to the underlying component so that inputs
    // etc. get disabled correctly.
    ,
    disabled: disabled,
    ref: ref
  }, otherProps), children);
});
ActionBlock.displayName = 'ActionBlock';